import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ViewLayout from "../../components/layouts/ViewLayout";

//#region Entity's dependencies
import TracingForm from "./tracingForm.view";
//#endregion

const Tracing = ({ component: Component, container, ...props }) => {
  const {
    privileges,
    record,
    Loading
  } = props;

  //#region States
  const [showRecordAlert, setShowRecordAlert] = useState(false);
  const [confirmInactivate, setConfirmInactivate] = useState({
    open: false,
    item: "",
    name: "",
    checked: false,
    message: "",
  });
  const [recordInfo, setRecordInfo] = useState({});
  const [isFormShowed, setFormShowed] = useState(false);
  let [isLoading, setLoading] = useState(false);
  if(Loading !== undefined){
    setLoading = Loading;
  }
  const [userPrivileges] = useState({
    read: privileges.filter(p => p.includes("PIF_TRACING_READ")).length > 0,
    modify: privileges.filter(p => p.includes("PIF_TRACING_MODIFY")).length > 0,
    resource: {
      read: privileges.filter(p => p.includes("PIF_RESOURCE_READ")).length > 0,
      modify: privileges.filter(p => p.includes("PIF_RESOURCE_MODIFY")).length > 0
    },
    log: {
      read: privileges.filter(p => p.includes("PIF_LOG_READ")).length > 0,
      modify: privileges.filter(p => p.includes("PIF_LOG_MODIFY")).length > 0
    },
    queue: {
      read: privileges.filter(p => p.includes("PIF_QUEUE_READ")).length > 0,
      modify: privileges.filter(p => p.includes("PIF_QUEUE_MODIFY")).length > 0
    },
    transaction: {
      read: privileges.filter(p => p.includes("PIF_TRANSACTION_READ")).length > 0,
      modify: privileges.filter(p => p.includes("PIF_TRANSACTION_MODIFY")).length > 0
    }
  }
);
  //#endregion

  //#region Effects
  useEffect(() => {
    if(record.id){
      setRecordInfo(record);
      setFormShowed(true);
    }
  }, [record]);
  //#endregion

  //#region custom

  return (
    <ViewLayout
      headerTitle={"Recursos"}
      confirmInactivate={confirmInactivate}
      setConfirmInactivate={setConfirmInactivate}
      showAlert={showRecordAlert}
      setShowAlert={setShowRecordAlert}
      isLoading={isLoading}
    >
      {isFormShowed ? (
        <TracingForm
          recordId={recordInfo.id}
          record={recordInfo}
          setCardState={setFormShowed}
          setLoading={setLoading}
          userPrivileges={userPrivileges}
        />
      ) : ( <></>
        // <CustomTable
        //   columns={columns}
        //   data={records}
        //   mainParam={"name"}
        //   buttons={getButtons()}
        //   havePagination={true}
        //   handleCellClick={handleCellClick}
        //   option={option}
        //   setOption={setOption}
        //   paramToDisable={"idstate"}
        // />
      )}
    </ViewLayout>
  );
};

//#endregion

//#region entities's declarations 
Tracing.propTypes = {
  
};

const mapStateToProps = (state) => ({
  record: state.enterpriseReducer.getEnterpriseByIDResponse,
});

const mapDispatchToProps = {
  
};

export default connect(mapStateToProps, mapDispatchToProps)(Tracing);
//#endregion